import { get_token } from "@/router";
import Swal from "sweetalert2";
import Discussion from "@/components/DiscussionForum/DiscussionForum.vue";


export default {
    props: {
        is_public: {
        type: Boolean,
        default: false,
        },
        portal_admin: {
        type: Boolean,
        default: false,
        },
    },
    components:{
     Discussion
    },
    mounted() {
        this.token_exists = get_token();
        this.user_id = this.get_user_id();
        this.filter_surveys();
        this.fetchQuestions();
        this.get_question_types();
        this.filter_polls();
    },

    data() {

        return ({
        user_details: {
            "user_role": '',
            "user_id": null,
        },
        selectedSurveyId: null,
        token_exists: false,
        surveys: [],
        activeVoiceTab: 'discussions',
        survey_name: '',
        survey_description: '',
        questions: [],
        showQuestionsForm: true,
        errors: {},
        answers: {}, 
        showResponsesFor: null,
        filteredQuestions: [],
        survey_survey_selectname: "",
        selectedQuestions: [],
        description: "",
        showQuestionForm: false,
        newQuestion: {
            text: '',
            question_number: '',
            type: '',
            options: [],
            is_mandatory: false,
        },
        question_types: [],
        showSelectedQuestions: false,
        createdQuestions: [],
        survey_questions: [],
        portal_id: null,
        selectedPollId: null,
        polls: [],
        poll_name: '',
        poll_description: '',
        expandedQuestions: new Map(),
        allowMultiple: false,
        options: [
        { value: '' },
        { value: '' },
        { value: '' }
      ],
      selectedPoll: null,

    })
    },
    methods: {
        getToken() {
        return get_token();
        },
        get_user_id() {
        const user_id = localStorage.getItem('user_id') || '';
        return user_id;
        },
        toggleSurvey(id) {
            this.selectedSurveyId = this.selectedSurveyId === id ? null : id;
        },
        on_input(index) {
            // If it's the last item and not empty, add a new blank option
             const lastIndex = this.options.length - 1;
                if (
                    index === lastIndex &&
                    this.options[lastIndex].value.trim() !== ""
                ) {
                    this.options.push({ value: "" });
                }
            },
        toggleSurveyResponses(id) {
            this.showResponsesFor = this.showResponsesFor === id ? null : id;
        },

            submitSurveyAnswers(survey) {
                const formData = new FormData();
                formData.append('survey_id', survey.id);

                const answeredQuestions = [];

                for (const [questionId, answer] of Object.entries(this.answers)) {
                    if (answer !== undefined && answer !== null) {
                        answeredQuestions.push({
                            question_id: Number(questionId),
                            answer: Array.isArray(answer) ? answer.join(',') : answer
                        });
                    }
                }

                formData.append('answers', JSON.stringify(answeredQuestions));

                $.ajax({
                    type: "POST",
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/answer_survey/`,
                    headers: {
                        'Authorization': `Token ${this.getToken()}`
                    },
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: (response) => {
                        if (response.status === 'success') {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: 'Your answers have been submitted successfully!',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.selectedSurveyId= null,
                            survey.is_answered = true;
                        }
                    },

                    error: () => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Something went wrong. Please try again later.',
                        });
                    },
                    complete: () => {
                        this.showQuestionsForm = false;
                        this.isSubmitting = false;
                    },

                });

            },

        filter_surveys() {
            const requestData = {
                filter_values: {
                    portal_id: this.$route.params.portal_id
                }
                };
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/filter_survey/`,
            method: 'POST',
            headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(requestData),
            success: (response) => {
                this.surveys = response.data; 
            },
            complete: () => {
                this.isLoading = false;
            }
        });
        },
        fetchQuestions() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
                method: "POST",
                headers: this.token_exists
                    ? { Authorization: `Token ${this.getToken()}` }
                    : {},
                success: (response) => {
                    this.questions = response.data.questions;
                },
                error: () => {
                    Swal.fire({
                        icon: "error",
                        title: "Failed to load questions",
                    });
                }
            });
        },
        onQuestionInput(event) {
            const inputValue = event.target.value.toLowerCase();
            this.filteredQuestions = this.questions.filter((q) =>
                q && q.question && q.question.toLowerCase().includes(inputValue)
            );
        },
        onQuestionSelect(event) {
            const selectedValue = event.target.value;
            const selectedQuestion = this.questions.find(q => 
                q && q.question && q.question === selectedValue
            );
            
            if (selectedQuestion) {
                if (this.activeVoiceTab === 'questionpoll') {
                    // For polls, directly fill in the form fields
                    this.newQuestion.text = selectedQuestion.question;
                    this.newQuestion.type = selectedQuestion.question_type.id;
                    
                    // Properly format options with text property
                    if (selectedQuestion.options && selectedQuestion.options.length > 0) {
                        this.newQuestion.options = selectedQuestion.options.map(opt => ({
                            id: opt.id || Date.now() + Math.random(),
                            text: opt.option || opt.text || ''
                        }));
                    } else {
                        this.newQuestion.options = [];
                    }
                    
                    this.newQuestion.is_mandatory = selectedQuestion.is_mandatory || false;
                    this.newQuestion.question_number = selectedQuestion.question_number || '';
                    this.filteredQuestions = [];
                } else {
                    this.selectQuestion(selectedQuestion);
                }
            }
        },

        selectQuestion(question) {
            if (!this.selectedQuestions.some(q => q.id === question.id)) {
                this.selectedQuestions.push(question);
            }

            this.newQuestion.text = question.question;
            this.newQuestion.type = question.question_type.id;
            this.newQuestion.options = question.options || [];
            this.newQuestion.is_mandatory = question.is_mandatory || false;
            this.newQuestion.question_number = question.question_number || '';

            if (!this.createdQuestions.some(q => q.id === question.id)) {
                this.createdQuestions.push({
                    text: question.question,
                    id: question.id,
                    type: question.question_type.id,
                    is_mandatory: question.is_mandatory || false,
                });
            }
            this.filteredQuestions = [];

            this.newQuestion = {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            };
        },
        validationforSurveyName() {
            this.errors = {};
            let valid = true;
            if (!this.survey_name || this.survey_name.trim() === '') {
                this.errors.survey_name = 'Survey name is required';
                valid = false;
            }
            return valid;
        },
        submitSurveyForm() {
            if (!this.validationforSurveyName()) {
                return;
            }
            const payload = {
                name: this.survey_name,
                description: this.survey_description,
                questions: this.selectedQuestions.map(q => q.id),
                portal_id: this.$route.params.portal_id
            };
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/create_survey/`,
                method: "POST",
                headers: { 
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    () => {
                        Swal.fire({
                            title: 'Creating survey...',
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            }
                        });
                    },
                    this.filter_surveys();

                    Swal.fire({
                        icon: 'success',
                        title: 'Survey Created',
                        text: 'Your survey has been successfully created!',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        // Reset form
                        this.survey_name = '';
                        this.description = '';
                        this.questions = [];
                        this.selectedQuestions = [];
                        this.createdQuestions = [];
                        this.errors ={};
                        if (this.$refs.quillSurveyEditorRef) {
                            this.$refs.quillSurveyEditorRef.setHTML('');
                        }
                        
                        // Switch to surveys tab
                        this.activeVoiceTab = 'surveys';
                    });
                },
                error: (xhr) => {
                    Swal.close();
                    if (
                        xhr.responseJSON.message
                    ) {
                        this.errors.survey_name = xhr.responseJSON.message;
                        return; // No popup
                        }
                }
            });
        },

        editSurvey(survey) {
            this.survey_id = survey.id;
            this.survey_name = survey.name;
            this.survey_description = survey.description;

            this.selectedQuestions = survey.survey_questions.map((q) => ({
                id: q.question.id,
                question: q.question.question,
            }));
            this.survey_survey_selectname = this.selectedQuestions.map((q) => q.question);
            this.createdQuestions = survey.survey_questions.map((q, i) => ({
                id: q.question.id,
                text: q.question.question,
                question_number: i + 1,
                type: q.question.question_type.id,
                options: q.question.options || [],
                is_mandatory: q.question.is_mandatory || false,
            }));

            this.newQuestion = {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            };

            this.activeVoiceTab = 'questions';
            this.showSurveyCreation = true;

            this.$nextTick(() => {
                if (this.$refs.quillSurveyEditorRef) {
                    this.$refs.quillSurveyEditorRef.setHTML(survey.description || "");
                }
            });
        },        

        cancelEdit() {
            this.survey_id = null;
            this.survey_name = '';
            this.description = '';
            this.selectedQuestions = [];
            this.createdQuestions = [];
            if (this.$refs.quillSurveyEditorRef) {
                this.$refs.quillSurveyEditorRef.setHTML('');
            }

            // Switch back to surveys tab
            this.activeVoiceTab = 'surveys';
        },
        
        submitSurvey() {
            this.survey_description = this.$refs.quillSurveyEditorRef.getHTML();
            this.survey_description = this.survey_description.replace(/<\/?p>/g, '').trim();

            if (!this.survey_description || this.survey_description === '<br>' || this.survey_description === '<br/>') {
                this.survey_description = '';
            }

            if (this.newQuestion.text && this.newQuestion.type) {
                this.addQuestionToSurvey()
                    .then(() => {
                        if (this.survey_id) {
                            this.updateSurvey();
                        } else {
                            this.submitSurveyForm();
                        }
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }

            if (this.survey_id) {
                this.updateSurvey();
                return;
            }
            this.submitSurveyForm();

        },

        updateSurvey() {
            this.survey_description = this.$refs.quillSurveyEditorRef.getHTML();
            
            this.survey_description = this.survey_description.replace(/<\/?p>/g, '').trim();
            
            if (!this.survey_description || this.survey_description === '<br>' || this.survey_description === '<br/>') {
                this.survey_description = '';
            }

            if (this.newQuestion.text && this.newQuestion.type) {

                this.addQuestionToSurvey()
                    .then(() => {
                        this.updateSurveyForm();
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }
            this.updateSurveyForm();
        },
        updateSurveyForm() {
            const payload = {
                survey_id: this.survey_id,
                name: this.survey_name,
                description: this.survey_description,
                questions: this.selectedQuestions.map(q => q.id),
            };

            Swal.fire({
                title: 'Updating survey...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_survey/`,
                method: "POST",
                headers: { 
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    this.filter_surveys();
                    Swal.fire({
                        icon: 'success',
                        title: 'Survey Updated',
                        text: 'Your survey has been successfully updated!',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        this.survey_id = null;
                        this.survey_name = '';
                        this.description = '';
                        this.questions = [];
                        this.selectedQuestions = [];
                        this.createdQuestions = [];
                        if (this.$refs.quillSurveyEditorRef) {
                            this.$refs.quillSurveyEditorRef.setHTML('');
                        }
                        
                        // Switch to surveys tab
                        this.activeVoiceTab = 'surveys';
                    });
                },
                error: () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Cannot Edit Survey',
                        text: 'This survey has already been answered and cannot be edited.',
                        confirmButtonText: 'OK'
                    });
                }

            });
        },
        get_question_types() {
              this.token_exists = get_token();
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
                method: "GET",
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                  this.question_types = response.data.question_types;
                },
                error: () => {
                  Swal.fire({
                    icon: "error",
                    title: "Failed to load question types",
                  });
                }
              });
            },
            removeCreatedQuestion(index) {
                const removed = this.createdQuestions.splice(index, 1)[0];

                this.selectedQuestions = this.selectedQuestions.filter(q => q.id !== removed.id);
            },
            toggleCheckboxAnswer(survey, questionId, option, isChecked) {
                this.survey_questions = survey.survey_questions;
                const question = this.survey_questions.find(q => q.question.id === questionId);

                if (question) {
                    if (!Array.isArray(question.answer)) {
                        question.answer = [];
                    }

                    if (isChecked) {
                        if (!question.answer.includes(option)) {
                            question.answer.push(option);
                        }
                    } else {
                        const index = question.answer.indexOf(option);
                        if (index !== -1) {
                            question.answer.splice(index, 1);
                        }
                    }

                    this.answers = {
                        ...this.answers,
                        [questionId]: question.answer.slice()
                    };
                }
            },
            saveAnswer(survey, questionId, value) {
                this.survey_questions = survey.survey_questions;
                const question = this.survey_questions.find(q => q.question.id === questionId);
                if (question) {
                    question.answer = value;
                }
            },
            addQuestionToSurvey() {
                return new Promise((resolve, reject) => {
                    if (!this.newQuestion.text || !this.newQuestion.type || !this.newQuestion.question_number) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Missing Information',
                            text: 'Please fill in all required fields for the question',
                        });
                        reject('Missing required fields');
                        return;
                    }
                    
                    // Check if the question already exists
                    const existingQuestion = this.questions.find(q => q.question === this.newQuestion.text);
                    if (existingQuestion) {
                        if (!this.selectedQuestions.some(q => q.id === existingQuestion.id)) {
                            this.selectedQuestions.push(existingQuestion);
                            this.createdQuestions.push({
                                text: existingQuestion.question,
                                id: existingQuestion.id,
                                type: existingQuestion.question_type.id,
                                is_mandatory: existingQuestion.is_mandatory || false,
                            });
                        }
                        this.newQuestion = {
                            text: '',
                            question_number: '',
                            type: '',
                            options: [],
                            is_mandatory: false,
                        };
                        
                        Swal.fire({
                            icon: 'success',
                            title: 'Question Added',
                            text: 'Existing question has been added to your survey',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        resolve();
                    } else {
                        // Create a new question via API
                        const formData = new FormData();
                        formData.append('question', this.newQuestion.text);
                        formData.append('question_type', this.newQuestion.type);
                        formData.append('question_number', this.newQuestion.question_number);
                        formData.append('is_mandatory', this.newQuestion.is_mandatory);
                        
                        // Add options if any
                        if (this.newQuestion.options && this.newQuestion.options.length > 0) {
                            this.newQuestion.options.forEach(option => {
                                if (option.text && option.text.trim() !== "") {
                                    formData.append('options', option.text.trim());
                                }
                            });
                        }
                        
                        Swal.fire({
                            title: 'Creating question...',
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            }
                        });

                        $.ajax({
                            url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
                            method: "POST",
                            headers: { Authorization: `Token ${this.getToken()}` },
                            data: formData,
                            processData: false,
                            contentType: false,
                            success: (response) => {
                                if (response.status === "success") {
                                    const newQuestion = response.question_data;
                                    
                                    // Add to selected questions
                                    if (newQuestion && newQuestion.id) {
                                        this.selectedQuestions.push({
                                            id: newQuestion.id,
                                            question: newQuestion.question
                                        });
                                        
                                        // Add to created questions list for display
                                        this.createdQuestions.push({
                                            text: newQuestion.question,
                                            id: newQuestion.id,
                                            type: newQuestion.question_type.id,
                                            is_mandatory: newQuestion.is_mandatory || false,
                                        });
                                        
                                        // Show success message
                                        Swal.fire({
                                            icon: 'success',
                                            title: 'Question Created',
                                            text: 'New question has been created and added to your survey',
                                            showConfirmButton: false,
                                            timer: 1500
                                        });
                                        
                                        // Reset the form for the next question
                                        this.newQuestion = {
                                            text: '',
                                            question_number: '',
                                            type: '',
                                            options: [],
                                            is_mandatory: false,
                                        };
                                        
                                        // Refresh questions list
                                        this.fetchQuestions();
                                        
                                        // Resolve the promise with the new question
                                        resolve(newQuestion);
                                    } else {
                                        Swal.fire({
                                            icon: 'warning',
                                            title: 'Question Created',
                                            text: 'Question was created but could not be added to survey. Please try again.',
                                        });
                                        reject('Question created but missing ID');
                                    }
                                } else {
                                    reject('Failed to create question');
                                }
                            },
                            error: () => {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Failed to create question on survey.',
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                reject('Failed to create question');
                            }
                        });
                    }
                });
            },
            
            getQuestionTypeName(typeId) {
                if (!typeId) return 'Unknown';
                
                const questionType = this.question_types.find(type => type.id === typeId);
                return questionType ? questionType.question_type : 'Unknown';
            },
            addOption() {
                if (!Array.isArray(this.newQuestion.options)) {
                    this.newQuestion.options = [];
                }
                
                const newOption = { id: Date.now(), text: '' };
                this.newQuestion.options.push(newOption);
            },
            removeOption(index) {
                this.newQuestion.options.splice(index, 1);
            },
            deleteSurvey(survey_id) {
                Swal.fire({
                    title: 'Are you sure?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        $.ajax({
                            type: "DELETE",
                            url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_survey/`,
                            data: JSON.stringify({ survey_id: survey_id }),
                            headers: {
                                'Authorization': `Token ${this.getToken()}`,
                                'Content-Type': 'application/json'
                            },
                            success: (response) => {
                                const status = response.status;
                                if (status === "success") {
                                    this.surveys = this.surveys.filter(survey => survey.id !== survey_id);
                                    Swal.fire({
                                        title: 'Deleted!',
                                        text: 'The survey has been deleted.',
                                        icon: 'success',
                                        showConfirmButton: false,
                                        timer: 1000
                                    })
                                } else {
                                    Swal.fire(
                                        'Failed!',
                                        response.message || 'An error occurred. Please try again.',
                                        'error'
                                    );
                                }
                            },
                            error: (xhr) => {
                                Swal.fire(
                                    'Failed!',
                                    xhr.responseJSON?.message || 'An error occurred. Please try again.',
                                    'error'
                                );
                            }
                        });
                    }
                });
            },
            async addQuestionToPoll() {
                if (!this.newQuestion.text || !this.newQuestion.type || !this.newQuestion.question_number) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Missing Information',
                        text: 'Please fill in all required fields for the question',
                    });
                    return;
                }

                // Check if the question already exists
                const existingQuestion = this.questions.find(q => q.question === this.newQuestion.text);
                if (existingQuestion) {
                    if (!this.selectedQuestions.some(q => q.id === existingQuestion.id)) {
                        this.selectedQuestions.push(existingQuestion);
                        this.createdQuestions.push({
                            text: existingQuestion.question,
                            id: existingQuestion.id,
                            type: existingQuestion.question_type.id,
                            is_mandatory: existingQuestion.is_mandatory || false,
                        });
                    }

                    // this.resetNewQuestionForm();

                    Swal.fire({
                        icon: 'success',
                        title: 'Question Added',
                        text: 'Existing question has been added to your survey',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    return;
                }

                // Prepare form data for new question
                const formData = new FormData();
                formData.append('question', this.newQuestion.text);
                formData.append('question_type', this.newQuestion.type);
                formData.append('question_number', this.newQuestion.question_number);
                formData.append('is_mandatory', this.newQuestion.is_mandatory);

                if (this.newQuestion.options && this.newQuestion.options.length > 0) {
                    this.newQuestion.options.forEach(option => {
                        if (option.text && option.text.trim() !== "") {
                            formData.append('options', option.text.trim());
                        }
                    });
                }

                Swal.fire({
                    title: 'Creating question...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                try {
                    const response = await $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
                        method: "POST",
                        headers: { Authorization: `Token ${this.getToken()}` },
                        data: formData,
                        processData: false,
                        contentType: false
                    });

                    if (response.status === "success" && response.question_data?.id) {
                        const newQuestion = response.question_data;

                        this.selectedQuestions.push({
                            id: newQuestion.id,
                            question: newQuestion.question
                        });

                        this.createdQuestions.push({
                            text: newQuestion.question,
                            id: newQuestion.id,
                            type: newQuestion.question_type.id,
                            is_mandatory: newQuestion.is_mandatory || false,
                        });

                        Swal.fire({
                            icon: 'success',
                            title: 'Question Created',
                            text: 'New question has been created and added to your survey',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        this.resetNewQuestionForm();
                        this.fetchQuestions();
                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Question Created',
                            text: 'Question was created but could not be added to survey. Please try again.',
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to create question.',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            },

validationforPollName() {
            this.errors = {};
            let valid= true;
            if (!this.poll_name || this.poll_name.trim() === '') {
                this.errors.poll_name = 'Poll name is required';
                valid = false;
            }
            if(!this.poll_question || this.poll_question.trim() === ''){
                this.errors.poll_question = 'A question is required';
                valid = false;
            }
            return valid;
        },
        submitPollForm() {
            if (!this.validationforPollName()) {
                return;
            }
            const answers = this.options
            .map((option, index) => ({ text: option.value?.trim(), order: index + 1 }))
            .filter(answer => answer.text);

            const payload = {
                poll_name: this.poll_name,
                portal_id: this.$route.params.portal_id,
                questions: [
                    {
                        question_text: this.poll_question,
                        question_type: this.allowMultiple ? "selection" : "checkbox",
                        options: answers
                    }
                ]
            };

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/create_poll/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    Swal.fire({
                        title: 'Creating poll...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    Swal.close();

                    this.filter_polls();
                    Swal.fire({
                        icon: 'success',
                        title: 'Poll Created',
                        text: 'Your poll has been successfully created!',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        this.resetPollForm();
                        this.activeVoiceTab = 'polls';
                    });
                },

                error: (xhr) => {
                    Swal.close();

                    this.errors.poll_name = xhr.responseJSON.message

                }
            });
        },

       resetPollForm() {
        this.poll_name = "";
        this.poll_description = "";
        this.allowMultiple = false;
        this.options = [{ value: "" }, { value: "" }, { value: "" }];
        },

        filter_polls() {
            const requestData = {
                filter_values: {
                    portal_id: this.$route.params.portal_id
                }
                };
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/filter_poll/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(requestData),
                success: (response) => {
                    this.polls = response.data; 
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
            },
            togglePoll(id) {
            this.selectedPollId = this.selectedPollId === id ? null : id;
        },
        toggleCheckboxAnswerP(poll, questionId, option, isChecked) {
                this.poll_questions = poll.poll_questions;
                const question = this.poll_questions.find(q => q.question.id === questionId);

                if (question) {
                    if (!Array.isArray(question.answer)) {
                        question.answer = [];
                    }

                    if (isChecked) {
                        if (!question.answer.includes(option)) {
                            question.answer.push(option);
                        }
                    } else {
                        const index = question.answer.indexOf(option);
                        if (index !== -1) {
                            question.answer.splice(index, 1);
                        }
                    }

                    this.answers = {
                        ...this.answers,
                        [questionId]: question.answer.slice()
                    };
                }
            },
        submitPollAnswers(poll) {
                const formData = new FormData();
                formData.append('poll_id', poll.id);

                const answeredQuestions = [];

                for (const [questionId, answer] of Object.entries(this.answers)) {
                    if (answer !== undefined && answer !== null) {
                        answeredQuestions.push({
                            question_id: Number(questionId),
                            answer: Array.isArray(answer) ? answer.join(',') : answer
                        });
                    }
                }

                formData.append('answers', JSON.stringify(answeredQuestions));

                $.ajax({
                    type: "POST",
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/answer_poll/`,
                    headers: {
                        'Authorization': `Token ${this.getToken()}`
                    },
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: (response) => {
                        if (response.status === 'success') {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: 'Your answers have been submitted successfully!',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.selectedPollId= null,
                            poll.is_answered = true;
                        }
                    },

                    error: () => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Something went wrong. Please try again later.',
                        });
                    },
                    complete: () => {
                        this.showQuestionsForm = false;
                        this.isSubmitting = false;
                    },

                });

            },
            togglePollResponses(id) {
            this.showResponsesFor = this.showResponsesFor === id ? null : id;
        },
        toggleQuestionResponses(questionId) {
            const currentValue = this.expandedQuestions.get(questionId);
            this.expandedQuestions.set(questionId, !currentValue);
        },
        editPoll(poll) {
            this.poll_id = poll.id;
            this.poll_name = poll.name;
            this.poll_description = poll.description;

            const q = poll.poll_questions[0]?.question;

            this.newQuestion = {
                id: q?.id || null,
                text: q?.question || '',
                question_number: q?.question_number || 1,
                type: q?.question_type?.id || '',
                options: (q?.options || []).map(opt => ({ id: opt.id, text: opt.option })),
                is_mandatory: q?.is_mandatory || false,
            };

            this.activeVoiceTab = 'questionpoll';
            this.showPollCreation = true;

            this.$nextTick(() => {
                if (this.$refs.quillPollEditorRef) {
                this.$refs.quillPollEditorRef.setHTML(poll.description || "");
                }
            });
            },

        cancelEditPoll() {
            this.poll_id = null;
            this.poll_name = '';
            this.description = '';
            this.selectedQuestions = [];
            this.createdQuestions = [];
            if (this.$refs.quillPollEditorRef) {
                this.$refs.quillPollEditorRef.setHTML('');
            }

            // Switch back to polls tab
            this.activeVoiceTab = 'polls';
        },

    updatePoll() {
            this.poll_description = this.$refs.quillPollEditorRef.getHTML();
            
            this.poll_description = this.poll_description.replace(/<\/?p>/g, '').trim();
            
            if (!this.poll_description || this.poll_description === '<br>' || this.poll_description === '<br/>') {
                this.poll_description = '';
            }

            if (this.newQuestion.text && this.newQuestion.type) {

                this.addQuestionToPoll()
                    .then(() => {
                        this.updatePollForm();
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }
            this.updatePollForm();
        },
        updatePollForm() {
            const payload = {
                poll_id: this.poll_id,
                name: this.poll_name,
                description: this.poll_description,
                questions: this.selectedQuestions.map(q => q.id),
            };

            Swal.fire({
                title: 'Updating poll...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_poll/`,
                method: "POST",
                headers: { 
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    this.filter_polls();
                    Swal.fire({
                        icon: 'success',
                        title: 'Poll Updated',
                        text: 'Your poll has been successfully updated!',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        this.poll_id = null;
                        this.poll_name = '';
                        this.description = '';
                        this.questions = [];
                        this.selectedQuestions = [];
                        this.createdQuestions = [];
                        if (this.$refs.quillPollEditorRef) {
                            this.$refs.quillPollEditorRef.setHTML('');
                        }
                        
                        // Switch to polls tab
                        this.activeVoiceTab = 'polls';
                    });
                },
                error: () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Cannot Edit Poll',
                        text: 'This poll has already been answered and cannot be edited.',
                        confirmButtonText: 'OK'
                    });
                }

            });
        },
        deletePoll(poll_id) {
                Swal.fire({
                    title: 'Are you sure?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        $.ajax({
                            type: "DELETE",
                            url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_poll/`,
                            data: JSON.stringify({ poll_id: poll_id }),
                            headers: {
                                'Authorization': `Token ${this.getToken()}`,
                                'Content-Type': 'application/json'
                            },
                            success: (response) => {
                                const status = response.status;
                                if (status === "success") {
                                    this.polls = this.polls.filter(poll => poll.id !== poll_id);
                                    Swal.fire({
                                        title: 'Deleted!',
                                        text: 'The poll has been deleted.',
                                        icon: 'success',
                                        showConfirmButton: false,
                                        timer: 1000
                                    })
                                } else {
                                    Swal.fire(
                                        'Failed!',
                                        response.message || 'An error occurred. Please try again.',
                                        'error'
                                    );
                                }
                            },
                            error: (xhr) => {
                                Swal.fire(
                                    'Failed!',
                                    xhr.responseJSON?.message || 'An error occurred. Please try again.',
                                    'error'
                                );
                            }
                        });
                    }
                });
            },
        openPollResponses(poll) {
            this.selectedPoll = poll;
            $('#pollResponsesModal').modal('show');
        },
        download_pdf() {
        const element = this.$refs.pdf_content;
        const options = {
        margin:       0.5,
        filename:     `${this.selectedPoll.name}_responses.pdf`,
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
        };
        html2pdf().from(element).set(options).save();
    },
    }
};